import {reloadWithoutGetParams, replaceUrlParam, getUrlParameter} from '@js/helpers/location';
import {sendRequest} from '@js/utils';
import {routes} from '@js/helpers/routes';
import '@plugins/jquery.autocomplete/jquery.autocomplete.css';
import '@plugins/jquery.autocomplete/jquery.autocomplete.min';
import {isEqual} from 'lodash';

function getFormParams(isDesktopForm = true) {
    const $modalFiltersForm = $('#modal-filter-form');
    const $filterForm = isDesktopForm ? $('form.ranking-filters').not($modalFiltersForm) : $modalFiltersForm;
    return `${$filterForm.serialize()}`;
}

function refreshAccreditationsPage(isDesktopForm = true) {
    window.location.search = getFormParams(isDesktopForm);
}

export function initFiltersListeners() {
    const $form = $('.sidebar__filters');
    const $multipleRegionSelect = $form.find('[name="regions[]"]');
    $multipleRegionSelect.selectpicker({
        noneSelectedText: 'Все',
        liveSearch: true
    });
    initMultipleSelectFilterListener($multipleRegionSelect);
    const body = $('body');
    body
        .on('click', '.remove-all-applied-filters', reloadWithoutGetParams)
        .on('click', '.remove-applied-filter', function () {
        const isMultiple = $(this).data('multiple') === true;
        const filterName = $(this).data('filter');
        let replacementValue;
        if (isMultiple) {
            const multipleFilterValue = $(this).data('multiple-value');
            const urlParamValues = getUrlParameter(filterName);
            replacementValue = urlParamValues.filter((item) => {
                return item != multipleFilterValue;
            });
        } else {
            replacementValue = '';
        }
        window.location.search = replaceUrlParam(filterName, replacementValue);
    });
    const $modalFiltersForm = $('#modal-filters');
    $modalFiltersForm
        .on('click', '#btnFilter', () => {
            refreshAccreditationsPage(false);
        });
    const $autocompleteInput = $('.page-with-sidebar__sidebar input[name="name"]');
    const location = routes.public.organizations.getOrganizationsList();
    if ($autocompleteInput.length) {
        initAutocomplete($autocompleteInput, location);
    }
}

function createApplyButtonWrapper() {
    return `<div class="apply-multiple-select">
        <button type="button" class="btn btn-xs btn-default apply-multiple-select__btn">
            Применить фильтр
        </button>
    </div>`;
}

export function initAutocomplete($autocompleteInput, location) {
    $(window)
        .scroll(() => {
            $autocompleteInput.autocomplete('hide');
        });
    sendRequest('get', location, {}, (res) => {
        if (res?.success) {
            const autocompleteValues = res.list;
            $autocompleteInput.autocomplete({
                minChars: 2,
                width: 500,
                lookup: autocompleteValues,
                triggerSelectOnValidInput: false,
                onSelect() {
                    const $form = $(this).closest('.ranking-filters');
                    if ($form.attr('id') !== 'modal-filter-form') {
                        refreshAccreditationsPage();
                    }
                },
            });
        }
    });
}

export function initMultipleSelectFilterListener($multipleSelects) {
    if ($multipleSelects.length) {
        const initialSelectedValues = {};
        $multipleSelects.each(function () {
            const $select = $(this);
            const id = $select.attr('id');
            initialSelectedValues[id] = $select.val();
        });
        let isRefreshPageStarted = false;
        const desktopIdName = 'accreditationsFilter';
        $multipleSelects
            .on('hidden.bs.select', function () {
                const $select = $(this);
                const id = $select.attr('id');
                $select.css('vertical-align', 'top');
                if (!isEqual(initialSelectedValues[id], $select.val()) && !isRefreshPageStarted) {
                    const $form = $(this).closest('form');
                    if ($form.attr('id') === desktopIdName) {
                        refreshAccreditationsPage();
                    }
                    isRefreshPageStarted = true;
                }
            })
            .on('loaded.bs.select', function () {
                const $select = $(this);
                const $selectDropdown = $select.closest('.sidebar__filter')
                    .find('.dropdown-menu.open');
                const $applyButtonWrapper = createApplyButtonWrapper();
                $selectDropdown.prepend($applyButtonWrapper);
                $selectDropdown
                    .on('click', '.apply-multiple-select__btn', function () {
                        const $form = $(this).closest('form');
                        if ($form.attr('id') === desktopIdName) {
                            refreshAccreditationsPage();
                        }
                        isRefreshPageStarted = true;
                    });
            });

    }
}
